<template>
    <div class="container pt-2">
        <h3>Resumo da Semana</h3>
        <div class="row justify-content-md-center pt-3">
            <!-- CARD NOVOS ORCAMENTOS -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setNovos">
                    <div class="card-header bg-success-title-light cardCustom">
                        <h5 class="text-success-title-light">Novos Orçamentos</h5>
                    </div>
                    <div class="card-body bg-success-body-light">
                        <p class="card-title text-secondary">{{ cardNovosSemanaMax }} Orçamentos Novos</p>
                    </div>
                </div>
            </div>
            <!-- CARD ORCAMENTOS ACEITOS -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setAceitos">
                    <div class="card-header bg-secondary-title-light cardCustom">
                        <h5 class="text-secondary-title-light">Propostas Aceitas</h5>
                    </div>
                    <div class="card-body bg-secondary-body-light">
                        <p class="card-title text-secondary">{{ cardAceitosSemanaMax }} Propostas Aceitas</p>
                    </div>
                </div>
            </div>
            <!-- CARD MOTORISTAS OCIOSOS @change="loadStatus()" -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setStatus">
                    <div class="card-header bg-purple-title-light headerCustom">
                        <div class="text-purple-title-light">
                            <div class="col-md-12">
                                <b-form-group>
                                    <b-form-select id="status" :options="statuses"
                                        v-model="temp.id"
                                        @change="getCardStatusSemana"
                                        placeholder="Informe o nome do status."
                                        class="textInputCmb"/>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <div class="card-body bg-purple-body-light">
                        <p class="card-title text-secondary" v-if="cardStatusSemanaMax">{{ cardStatusSemanaMax }} Transportes neste Status</p>
                        <p class="card-title text-secondary" v-else>Selecione o Status</p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <p class="text-right pt-2 text-sm pb-3"><i>Informações da semana de {{ firstDay }} à {{ lastDay }}</i></p>
        </div>
        <h3 class="pt-3">Dados:</h3>
        <div class="row justify-content-md-center">
            <div class="col-md-12">
                <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
                    <b-table v-if="modo==='novosSemana'" hover striped class="text-center align-middle table" :items="cardNovosSemana" :fields="fieldsNovosSemana">
                    </b-table>
                    <div class="row" v-if="exibeRodapeNovosSemana && modo==='novosSemana'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='aceitosSemana'" hover striped class="text-center align-middle table" :items="cardAceitosSemana" :fields="fieldsAceitosSemana">
                    </b-table>
                    <div class="row" v-if="exibeRodapeAceitosSemana && modo==='aceitosSemana'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='status'" hover striped class="text-center align-middle table" :items="cardStatusSemana" :fields="fieldsStatus">
                    </b-table>
                    <div class="row" v-if="exibeRodapeSS && modo==='status'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <b-table v-if="modo==='novosSemana'" hover striped class="text-center align-middle table" :items="cardNovosSemana" :fields="fieldsNovosSemana">
                    </b-table>
                    <div class="row" v-if="exibeRodapeNovosSemana && modo==='novosSemana'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='aceitosSemana'" hover striped class="text-center align-middle table" :items="cardAceitosSemana" :fields="fieldsAceitosSemana">
                    </b-table>
                    <div class="row" v-if="exibeRodapeAceitosSemana && modo==='aceitosSemana'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='status'" hover striped class="text-center align-middle table" :items="cardStatusSemana" :fields="fieldsStatus">
                    </b-table>
                    <div class="row" v-if="exibeRodapeSS && modo==='status'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: "funcionarioHome",
    data: function() {
        return {
            modo: 'novosSemana',
            cardStatusSemana: [],
            cardStatusSemanaMax: '',
            cardNovosSemana: [],
            cardNovosSemanaMax: '',
            cardAceitosSemana: [],
            cardAceitosSemanaMax: '',
            temp: {},
            statuses: [
                { value: 'ORCAMENTO', text: 'Orçamento' },
                { value: 'AUTORIZANDO', text: 'Autorizando' },
                { value: 'ACEITO', text: 'Aceito' },
                { value: 'PAGO', text: 'Pago' },
                { value: 'ESTORNADO', text: 'Estornado' },
                { value: 'AGUARDANDO PAGAMENTO', text: 'Aguardando Pagamento' },
                { value: 'AGUARDANDO ESTORNO', text: 'Aguardando Estorno' },
                { value: 'REJEITADO', text: 'Rejeitado' }
            ],
            fieldsNovosSemana: [
                { key: 'codigo', label: 'Código', sortable: true },
                { key: 'origem', label: 'Origem', sortable: true },
                { key: 'destino', label: 'Destino', sortable: true },
                { key: 'cliente_nome', label: 'Cliente', sortable: true },
                { key: 'caminhao_titulo', label: 'Caminhão', sortable: true },
                { key: 'carga_titulo', label: 'Carga', sortable: true },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData' }
            ],
            fieldsAceitosSemana: [
                { key: 'codigo', label: 'Código', sortable: true },
                { key: 'cliente_nome', label: 'Cliente', sortable: true },
                { key: 'funcionario_nome', label: 'Funcionário', sortable: true },
                { key: 'transacao_meioPagamento', label: 'Forma de Pagamento', sortable: true },
                { key: 'transacao_referencia', label: 'ID Transação', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData' }
            ],
            fieldsStatus: [
                { key: 'codigo', label: 'Código', sortable: true },
                { key: 'data', label: 'Data de Atualização', sortable: true, formatter: 'formatData' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            firstDay: '',
            lastDay: '',
            exibeRodapeNovosSemana: true,
            exibeRodapeAceitosSemana: true,
            exibeRodapeSS: true
        }
    },
    methods: {
        getWeek() {
            this.firstDay = new Date()
            this.lastDay = new Date()
            const hoje = new Date()
            const diaSemana = hoje.getDay()
            if(diaSemana===0) {
                this.lastDay.setDate(this.lastDay.getDate() + 6)
            }else if(diaSemana===1) {
                this.firstDay.setDate(this.firstDay.getDate() - 1)
                this.lastDay.setDate(this.lastDay.getDate() + 5)
            }else if(diaSemana===2) {
                this.firstDay.setDate(this.firstDay.getDate() - 2)
                this.lastDay.setDate(this.lastDay.getDate() + 4)
            }else if(diaSemana===3) {
                this.firstDay.setDate(this.firstDay.getDate() - 3)
                this.lastDay.setDate(this.lastDay.getDate() + 3)
            }else if(diaSemana===4) {
                this.firstDay.setDate(this.firstDay.getDate() - 4)
                this.lastDay.setDate(this.lastDay.getDate() + 2)
            }else if(diaSemana===5) {
                this.firstDay.setDate(this.firstDay.getDate() - 5)
                this.lastDay.setDate(this.lastDay.getDate() + 1)
            }else if(diaSemana===6) {
                this.firstDay.setDate(this.firstDay.getDate() - 6)
            }

            const tfDia = this.firstDay.getDate().toString()
            const tfDiaF = (tfDia.length == 1) ? '0'+tfDia : tfDia
            const tfMes  = (this.firstDay.getMonth()+1).toString()
            const tfMesF = (tfMes.length == 1) ? '0'+tfMes : tfMes
            const tfAnoF = this.firstDay.getFullYear()
            this.firstDay = tfDiaF + '/' + tfMesF + '/' + tfAnoF
            this.temp.inicio = tfAnoF + '-' + tfMesF + '-' + tfDiaF

            const tlDia = this.lastDay.getDate().toString()
            const tlDiaF = (tlDia.length == 1) ? '0'+tlDia : tlDia
            const tlMes  = (this.lastDay.getMonth()+1).toString()
            const tlMesF = (tlMes.length == 1) ? '0'+tlMes : tlMes
            const tlAnoF = this.lastDay.getFullYear()
            this.lastDay = tlDiaF + '/' + tlMesF + '/' + tlAnoF
            this.temp.final = tlAnoF + '-' + tlMesF + '-' + tlDiaF
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        setNovos() {
            this.modo = 'novosSemana'
            this.loadCardNovosSemana()
        },
        setAceitos() {
            this.modo = 'aceitosSemana'
            this.loadCardAceitosSemana()
        },
        setStatus() {
            this.modo = 'status'
            this.getCardStatusSemana()
        },
        getCardStatusSemana() {
            this.loadCardStatusSemanaMax()
            this.loadCardStatusSemana()
        },
        loadCardStatusSemanaMax() {
            const url = `${baseApiUrl}/backend/cardStatusSemanaMax.php?status=${this.temp.id}&inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardStatusSemanaMax = res.data[0].max
            })
        },
        loadCardStatusSemana() {
            const url = `${baseApiUrl}/backend/cardStatusSemana.php?status=${this.temp.id}&inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardStatusSemana = res.data
                    this.exibeRodapeSS = false
                }else{
                    this.cardStatusSemana = []
                    this.exibeRodapeSS = true
                }
            })
        },
        loadCardNovosSemanaMax() {
            const url = `${baseApiUrl}/backend/cardNovosSemanaMax.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardNovosSemanaMax = res.data[0].max
            })
        },
        loadCardNovosSemana() {
            const url = `${baseApiUrl}/backend/cardNovosSemana.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardNovosSemana = res.data
                    this.exibeRodapeNovosSemana = false
                }else{
                    this.loadCardNovosSemana = []
                    this.exibeRodapeNovosSemana = true
                }
            })
        },
        loadCardAceitosSemanaMax() {
            const url = `${baseApiUrl}/backend/cardAceitosSemanaMax.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardAceitosSemanaMax = res.data[0].max
            })
        },
        loadCardAceitosSemana() {
            const url = `${baseApiUrl}/backend/cardAceitosSemana.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardAceitosSemana = res.data
                    this.exibeRodapeAceitosSemana = false
                }else{
                    this.cardAceitosSemana = []
                    this.exibeRodapeAceitosSemana = true
                }
            })
        }
    },
    mounted() {
        this.getWeek()
        this.loadCardNovosSemana()
        this.loadCardNovosSemanaMax()
        this.loadCardAceitosSemanaMax()
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
    .bg-success-title-light {
        background-color: rgba(40,167,69,0.75);
    }

    .text-success-title-light {
        color: #d3fddd !important;
    }

    .bg-success-body-light {
        background-color: rgba(40,167,69,0.15);
    }

    .bg-info-title-light {
        background-color: rgba(23, 162, 184, 0.75);
    }

    .text-info-title-light {
        color: #bcebf3 !important;
    }

    .bg-info-body-light {
        background-color: rgba(23,162,184,0.15);
    }

    .bg-danger-title-light {
        background-color: rgba(220,53,69,0.75);
    }

    .text-danger-title-light {
        color: #fce6e8 !important;
    }

    .bg-danger-body-light {
        background-color: rgba(220,53,69,0.15);
    }

    .bg-warning-title-light {
        background-color: rgba(255,193,7,0.75);
    }

    .text-warning-title-light {
        color: #fff9e7 !important;
    }

    .bg-warning-body-light {
        background-color: rgba(255,193,7,0.15);
    }

    .bg-secondary-title-light {
        background-color: rgba(108,117,125,0.75);
    }

    .text-secondary-title-light {
        color: #eaeaea !important;
    }

    .bg-secondary-body-light {
        background-color: rgba(108,117,125,0.15);
    }

    .bg-purple-title-light {
        background-color: rgba(111,66,193,0.75);
    }

    .text-purple-title-light {
        color: #dbd3e8 !important;
    }

    .bg-purple-body-light {
        background-color: rgba(111,66,193,0.15);
    }

    .text-sm {
        font-size: 0.8rem;
        color: #6C757D;
    }

    .cardCustom {
        border-radius: 0 !important;
    }

    .headerCustom {
        height: 57px !important;
        padding-top: 3px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
    }

    .textInputCmb {
    /* border: 1px solid rgb(220, 220, 220); */
    border: 0;
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 1.25rem !important;
    color: #dbd3e8 !important;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>